<template>
  <div>
    <CButton color="link" class="px-0 mb-2" :to="{ path: '/admins/packageList' }">
      <CIcon name="cil-arrow-left" /> Packages
    </CButton>
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <h1 class="h4 mb-1 font-weight-bold">
          {{ obj.id ? obj.name || "Package" : "New package" }}
        </h1>
        <p class="text-muted mb-0">Price, limits and renewal for this subscription plan</p>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardBody>
            <div v-if="loadError" class="text-center p-5">
              <CIcon name="cil-warning" size="xl" class="text-danger mb-3" />
              <h2 class="h6 font-weight-bold">Couldn't load this package</h2>
              <p class="text-muted">Check your connection and try again.</p>
              <CButton color="primary" @click="resetObj">Retry</CButton>
            </div>
            <CForm v-else @submit.prevent="submit">
              <CInput label="Name *" horizontal v-model="obj.name" />
              <CRow form class="form-group">
                <CCol tag="label" sm="3" class="col-form-label"> Description </CCol>
                <CCol sm="9">
                  <CTextarea rows="5" v-model="obj.description" />
                </CCol>
              </CRow>

              <CInput label="Price *" horizontal prepend="RM" inputmode="decimal" v-model="obj.price" />
              <CInput
                label="Reseller commission"
                horizontal
                prepend="RM"
                inputmode="decimal"
                v-model="obj.resellerCommission"
              />
              <CInput
                label="Referrer commission"
                horizontal
                prepend="RM"
                inputmode="decimal"
                v-model="obj.referrerCommission"
              />
              <CInput label="Months *" horizontal inputmode="numeric" v-model="obj.totalMonth" />

              <CRow form class="form-group">
                <CCol tag="label" sm="3" class="col-form-label"> Active </CCol>
                <CCol sm="9">
                  <CSwitch class="mr-1" color="primary" :checked.sync="obj.isActive" />
                </CCol>
              </CRow>

              <CInput label="Max users" horizontal inputmode="numeric" v-model="obj.maxUsers" />
              <CInput label="Max storage" horizontal inputmode="numeric" v-model="obj.maxStorage" />
              <CRow form class="form-group">
                <CCol tag="label" sm="3" class="col-form-label"> Auto renew </CCol>
                <CCol sm="9">
                  <CSwitch class="mr-1" color="primary" :checked.sync="obj.autoRenew" />
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-between">
            <CButton color="light" :disabled="saving" :to="{ path: '/admins/packageList' }">
              Cancel
            </CButton>
            <CButton color="primary" :disabled="saving" @click="submit">
              {{ obj.id ? "Save" : "Add package" }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import PackageApi from "@/lib/packageApi";

export default {
  name: "Package",
  data: () => {
    return {
      obj: {
        isActive: false,
      },
      saving: false,
      loadError: false,
      api: new PackageApi(),
    };
  },
  mounted() {
    this.resetObj();
  },
  methods: {
    resetObj() {
      var self = this;
      self.loadError = false;
      if (self.$route.params.id) {
        self.api
          .get(self.$route.params.id)
          .then((response) => {
            self.obj = response.result;
          })
          .catch((error) => {
            console.error(error);
            self.loadError = true;
          });
      } else {
        self.obj = {};
      }
    },
    submit() {
      var self = this;
      if (self.saving) return;
      self.saving = true;
      const request = !self.obj.id
        ? self.api.create(self.obj)
        : self.api.update(self.obj);
      request
        .then(() => {
          if (!self.obj.id) {
            self.$toast.success("Package added");
            self.$router.push({ path: "/admins/packageList" });
          } else {
            self.$toast.success("Package saved");
            self.resetObj();
          }
        })
        .catch(({ data }) => {
          self.$toast.error(
            "Couldn't save the package. " + helper.getErrorMessage(data)
          );
        })
        .finally(() => {
          self.saving = false;
        });
    },
  },
};
</script>
